import { BoxDetailProps, BoxItem } from '../interface'
import { getFormatMessage } from '@/utils/utils'
import { LeftOutlined } from '@ant-design/icons'
import { Drawer, Space } from 'antd'
import React from 'react'
import { BoxDetail } from '.'

export interface BoxDetailDrawerProps
  extends Pick<
    BoxDetailProps,
    | 'values'
    | 'onBoxDetailLoad'
    | 'onBoxTemplateLoad'
    | 'onBoxAuditListLoad'
    | 'onBoxLogListLoad'
    | 'onBoxValueRead'
    | 'onBoxValueWrite'
    | 'onBoxNetworkModeUpdate'
    | 'onBoxNetworkUpdate'
    | 'onBoxApnUpdate'
    | 'onBoxConnectionUpdate'
    | 'onBoxTimeUpdate'
    | 'onBoxVariablePushChange'
    | 'onBoxAlarmPushChange'
    | 'onBoxValueSubscribe'
    | 'onBoxWifiLoad'
  > {
  box?: BoxItem
  visible?: boolean
  onVisibleChange?: (visible: boolean) => void
}

export const BoxDetailDrawer = (props: BoxDetailDrawerProps) => {
  const {
    box,
    visible,
    values,
    onVisibleChange,
    onBoxDetailLoad,
    onBoxTemplateLoad,
    onBoxAuditListLoad,
    onBoxLogListLoad,
    onBoxValueWrite,
    onBoxValueRead,
    onBoxValueSubscribe,
    onBoxNetworkModeUpdate,
    onBoxNetworkUpdate,
    onBoxApnUpdate,
    onBoxConnectionUpdate,
    onBoxTimeUpdate,
    onBoxVariablePushChange,
    onBoxAlarmPushChange,
    onBoxWifiLoad
  } = props
  const titleStyle = {
    fontSize: 12
  }
  const formatMessage = getFormatMessage()
  const handleDismissDetail = () => {
    onVisibleChange?.(false)
  }

  return (
    <Drawer
      destroyOnClose={true}
      maskClosable={false}
      title={
        <Space>
          <span style={{ cursor: 'pointer' }} onClick={handleDismissDetail}>
            <LeftOutlined />
            <span style={{ marginLeft: 5 }}>
              {formatMessage({ id: 'app.box.detail.title' })}
            </span>
          </span>
          {box?.alias && <span style={titleStyle}>{`${box.alias}`}</span>}
          {box?.tags && <span style={titleStyle}>|</span>}
          {box?.tags && <span style={titleStyle}>{box.tags}</span>}
        </Space>
      }
      visible={visible}
      onClose={handleDismissDetail}
      width={1200}
      bodyStyle={{ padding: 0 }}
    >
      <BoxDetail
        boxItem={box}
        values={values}
        onBoxDetailLoad={onBoxDetailLoad}
        onBoxTemplateLoad={onBoxTemplateLoad}
        onBoxAuditListLoad={onBoxAuditListLoad}
        onBoxLogListLoad={onBoxLogListLoad}
        onBoxValueRead={onBoxValueRead}
        onBoxNetworkModeUpdate={onBoxNetworkModeUpdate}
        onBoxNetworkUpdate={onBoxNetworkUpdate}
        onBoxApnUpdate={onBoxApnUpdate}
        onBoxConnectionUpdate={onBoxConnectionUpdate}
        onBoxTimeUpdate={onBoxTimeUpdate}
        onBoxVariablePushChange={onBoxVariablePushChange}
        onBoxAlarmPushChange={onBoxAlarmPushChange}
        onBoxValueSubscribe={onBoxValueSubscribe}
        onBoxValueWrite={onBoxValueWrite}
        onBoxWifiLoad={onBoxWifiLoad}
      />
    </Drawer>
  )
}
